/* Copyright Verge Technologies 2018
 * @file about.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @descripton About page
 */

// Modules
import React from 'react';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';

const Terms = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <div className="page-heading heading-about">Separations Terms &amp; Conditions</div>
      <div className="page-content">
        <div className="content">
          <h1>Website terms and conditions of use</h1>
          <p>
            Welcome to the Separations website www.separations.co.za. 
            The website provides information about the company Promolab (Pty) Ltd, 
            t/a Separations. The website is owned by Separations, 
            hosted by Verge Technologies (PTY) Ltd, and is located within the Republic of South Africa.
            By accessing and using this website, you agree to be bound by the terms and conditions 
            set out in this notice. If you do not wish to be bound by these terms and conditions, 
            then you may not access, display, use, download, copy or distribute any of the content 
            of this website.
          </p>
          <hr />

          <h1>Your use of the website</h1>
          <p>
            You agree that your use of this website is for lawful purposes only. 
            You agree that you will not use this website for any unlawful purpose, 
            including committing a criminal offence, gaining unauthorised access to 
            other computer systems, or transmitting unlawful material.
          </p>
          <hr />

          <h1>Choice of law</h1>
          <p>
            You agree to access and use this site entirely at your own risk. Please 
            read the Exclusion of Liability clauses below.
          </p>
          <hr />

          <h1>Accuracy of information</h1>
          <p>
            While every effort is made to ensure that the information provided on this website is 
            current and accurate, you should not assume that this is always the case, and should 
            consult other sources before making any decision to act on this information.
          </p>  
          <hr />

          <h1>Your privacy</h1>
          <p>
            We respect the privacy of all visitors to this site. You may use this site without providing 
            any personal information. However, so that we can regularly assess and improve the site, 
            we collect information on the number of visits to the site, pages viewed, etc.
          </p>   
          <hr />   

          <h1>Copyright and use of material</h1>
          <p> 
            Separations retains copyright in the website and all current and future content displayed 
            on the website which is not owned by third parties. This website and its contents may not 
            be reproduced, duplicated, copied, resold or otherwise used for any commercial purpose 
            without the express prior written consent of Separations.           
          </p>   
          <hr />   

          <h1>Your comments</h1>
          <p>  
            We value feedback received from visitors to our site. However, you agree not to transmit 
            any material that is unlawful, harmful, defamatory, abusive, threatening, vulgar or obscene. 
            You remain liable to any third party for your comments, and Separations is not liable to 
            any third party for the content of your comments. Please also note that we cannot respond 
            to all feedback we receive.          
          </p>   
          <hr />       

          <h1>Linking</h1>
          <p> 
            Any third party wishing to link to this website from their website must obtain permission 
            from Sparations, and permission may be granted on terms and conditions agreed.           
          </p>   
          <hr />       

          <h1>Exclusion of liability</h1>
          <p>  
            You expressly agree that the use of this website is entirely at your own risk. The website 
            and all its contents are provided on an “as is” basis, and Separations makes no representations 
            or warranties of any kind, whether express or implied, to the accuracy of the contents of the 
            website. Separations does not warrant that the website’s functions will be uninterrupted or 
            error-free, or that the site or its server is free from viruses or other harmful components.
          </p> 
          <p> 
            Separations, its owners, directors, employees, officials, suppliers, agents and/or representatives 
            shall not be liable for any loss or damage, whether direct, indirect or consequential, or any 
            expense of any nature whatsoever, which may be suffered by the user, which arises directly or 
            indirectly from reliance of the website and/or its content.
          </p> 
          <p>  
            Separations, its agents or suppliers shall not be responsible for any direct or indirect special 
            consequential or other damage of any kind whatsoever suffered or incurred by you related to your 
            use of, or your inability to access or use, the content or the website or any functionality of the 
            website or of any linked website, even where Separations is expressly advised thereof.
          </p> 
          <p>  
            You will indemnify Separations, its owners, directors, employees, officials, agents, suppliers or 
            representatives, and keep them fully indemnified, from and against any loss or damage suffered or 
            liability incurred in respect of any third party, which arises from your use of this website.          
          </p>   
          <hr />       

          <h1>Contact details</h1>
          <p>   
            Contact details for any purposes related to these terms and conditions:<br/>
            Telephone: +27 (0)11 919-1000<br/>
            Fax: +27 (0)11 919-1200<br/>
            E-mail: info@separations.co.za<br/>         
          </p>   
          <hr />       
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;



// WEBPACK FOOTER //
// ./src/pages/termsAndConditions/termsAndConditions.page.js